import { Grid } from '@mui/material';
import React from 'react';
import { FishGroupSummary } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-result.type';
import ScenarioFishGroupInputs from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-result-tab/fish-groups/scenario-fish-group-inputs';
import ScenarioFishGroupProgram from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-result-tab/fish-groups/scenario-fish-group-program';

type Props = {
  item: FishGroupSummary;
};

const ScenarioFishGroupRowBody: React.FC<Props> = ({ item }) => {
  return (
    <Grid container spacing={4}>
      <Grid size={{ xs: 5 }}>
        <ScenarioFishGroupInputs item={item} />
      </Grid>
      <Grid size={{ xs: 7 }}>
        <ScenarioFishGroupProgram item={item} />
      </Grid>
    </Grid>
  );
};

export default React.memo(ScenarioFishGroupRowBody);
